export default __webpack_public_path__ + "static/media/5.8abe5a63.svg";